export type SpaceKind = 'authored' | 'published' | 'detached'
export type PaletteKind = 'none' | 'go' | 'sync' | 'index' | 'update'

export type ContextModel = {
  space: SpaceKind
  palette: PaletteKind
}

export type PaletteAvailabilityState = 'enabled' | 'disabled'

export type PaletteAvailability = Record<Exclude<PaletteKind, 'none' | 'update'>, PaletteAvailabilityState>

export const isDetachedSpace = (space: SpaceKind): boolean => space === 'detached'

export const isEditableSpace = (space: SpaceKind): boolean => space === 'authored'

export const isPersistentSpace = (space: SpaceKind): boolean => space !== 'detached'

export const isCloudPalette = (palette: PaletteKind): boolean => palette === 'sync'

export const selectPaletteAvailability = (input: {
  canOpenIndex: boolean
  canOpenSync: boolean
}): PaletteAvailability => ({
  go: 'enabled',
  sync: input.canOpenSync ? 'enabled' : 'disabled',
  index: input.canOpenIndex ? 'enabled' : 'disabled'
})
